<template>
  <qx-card-form title="车辆信息">
    <span slot="titleLeft" class="noInsuranceTip">
      该车辆暂无保险信息，去
      <span class="primary cur" @click="toAddInsurance">新增</span>
    </span>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="car" slot-scope="prop">
        <ChooseCar :isRadio="true" v-model="prop.form.car" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            default: {},
            slot: true,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            disabled: true,
          },
          {
            label: '品牌名称',
            value: 'brandModel',
            type: 'input',
            disabled: true,
          },
          {
            label: '品牌型号',
            value: 'brandModelExt',
            type: 'input',
            disabled: true,
          },
          {
            label: '保险公司',
            value: 'insuranceCompany',
            type: 'input',
            disabled: true,
          },
          {
            label: '被保险人',
            value: 'insuranceUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '起保日期',
            value: 'insuranceStartDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '终保日期',
            value: 'insuranceEndDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '保单号',
            value: 'insuranceNumber',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    toAddInsurance () {
      this.jump({
        label: '新增保险',
        url: '/manage/cost/car/car/addInsurance',
        full: true,
      });
    },

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'SYS_STATE_DESC',
      });
      this.baseForm.stateOptions = enumsList[0];
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      if (data.state !== undefined || data.state !== null) {
        data.state = String(data.state);
      }
      this.$nextTick(() => {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !this.$route.query.id,
          names: ['state', 'customerCode'],
        });
      });
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.noInsuranceTip{
  margin-left: 16px;
  color: #999;
}
</style>
